<template>
  <div class="library-content-placeholder">
<!--    <div id="library-content" style="width: 100%"></div>-->
  </div>
</template>

<script>
import { start } from 'qiankun'
import { registerApps } from './config/index'
import { armLoadWatchdog } from '@common/qiankunWatchdog'
import common from "@common/common";
import { mapGetters } from 'vuex'

export default {
  name: 'unifiedContentLibrary',
  computed: {
    ...mapGetters('unifiedContentLibrary', ['getContentInstance']),
    contentInstance(){
      return this.getContentInstance
    }
  },
  methods: {

  },
  mounted() {
    // 子应用加载失败兜底：每次进入都重新武装，不依赖 qiankunStarted 标记
    armLoadWatchdog(this)

    if (!window.qiankunStarted) {
      window.qiankunStarted = true

      const parentInstance = {
        uploadClick: ()=>{
          this.$store.dispatch('unifiedContentLibrary/uploadBtnClick')
        },
        getUserKeys: ()=>{
          return common.userKeys()
        },
        getCommon: ()=>{
          return common
        },
        registerContentInstance: (instance)=>{
          this.$store.dispatch('unifiedContentLibrary/setContentInstance', {...this.contentInstance, ...instance})
        },
        updateUploadList: (list)=>{
          this.$store.dispatch('unifiedContentLibrary/setUploadList', list)
        },
        updateUploadStatus: (data)=>{
          this.$store.dispatch('unifiedContentLibrary/setUploadStatus', data)
        },
        toggleUploadModal: (val)=>{
          this.$store.dispatch('unifiedContentLibrary/setIsShowUploadModal', val)
        },
        setDetailInfo: (data, bool)=>{
          this.$store.dispatch('unifiedContentLibrary/setIsDetail', bool)
          this.$store.dispatch('unifiedContentLibrary/setDetailInfo', data)
        },
        getSystemConfig: ()=>{
          return this.$_syscfg
        },
        getThis: ()=>{
          return this
        }

      }

      registerApps(parentInstance,'/unifiedContentLibrary')
      setTimeout(()=>{
        start({
          sandbox: {
            experimentalStyleIsolation: false // 样式隔离
          }
        })
      })

    }
  },
  beforeDestroy() {
    clearTimeout(this._loadWatchdogTimer)
  }
}
</script>


